/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_MandarinInputs */



/**
* | output |
* | --- |
* | "Mandarin" |
*
* @param {Speechmatics_Target_Language_MandarinInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_mandarin = /** @type {((inputs?: Speechmatics_Target_Language_MandarinInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_MandarinInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mandarin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mandarin")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mandarino")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Мандарин")
	if (locale === "es") return /** @type {LocalizedString} */ ("mandarín")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("普通话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("北京語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अकर्मण्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mandarim")
	return /** @type {LocalizedString} */ ("Mandarin")
});